import { render, staticRenderFns } from "./StaffDetailView.vue?vue&type=template&id=1c50022d&"
import script from "./StaffDetailView.vue?vue&type=script&lang=js&"
export * from "./StaffDetailView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports